import { ContentViewStyle } from '@levelapp/softfabric';
export default class ResearchInputViewStyle extends ContentViewStyle {
    constructor() {
        super(...arguments);
        this.input = {
            flexDirection: 'row',
            marginRight: 5,
            marginBottom: 25,
            height: 25,
        };
        this.textInFront = {
            marginRight: 5,
            alignSelf: 'center',
        };
        this.inputView = {
            flex: 1,
            flexDirection: 'row',
            alignSelf: 'stretch',
        };
        this.button = {
            position: 'absolute',
            right: 0,
            alignSelf: 'center',
            marginRight: 5,
        };
        this.containerInput = {
            flexDirection: 'row',
            flex: 1,
            borderColor: 'gray',
            borderWidth: 1,
            borderRadius: 5,
        };
    }
}
